import {
  COMPANY_LOGO_FIELD,
  CompanyLogoResponse,
  CompanyPatch,
  CompanySchema,
} from '@siteday/shared';
import type { z } from 'zod';

import { api, buildUrl, request } from './client';

export const getCompany = () => api.get('/company', CompanySchema);

export const patchCompany = (patch: z.infer<typeof CompanyPatch>) =>
  api.patch('/company', CompanyPatch.parse(patch), CompanySchema);

/** POST /company/logo — multipart field `logo`, PNG/JPEG ≤ 2 MB; the API resizes and answers { logoUrl }. */
export async function uploadLogo(file: File) {
  const form = new FormData();
  form.append(COMPANY_LOGO_FIELD, file);
  return request('/company/logo', { method: 'POST', form, schema: CompanyLogoResponse });
}

/** GET /company/report-preview.pdf — the shared sample rendered under the current report layout (W11 preview). */
export const reportPreviewUrl = () => buildUrl('/company/report-preview.pdf');
